import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
    path: '/userGoods',
    component: Layout2,
    meta: {
        zhtitle: zh.m.router.common.USERGOODS_MANAGEMENT,
        jatitle: ja.m.router.common.USERGOODS_MANAGEMENT,
    },
    children: [{
        path: '',
        name: 'userGoods',
        component: () => import( /* webpackChunkName: "jp.ticket" */ '@/merchanAdmin/userGoods/list'),
        meta: {
            zhtitle: zh.m.router.common.USERGOODS_MANAGEMENT,
            jatitle: ja.m.router.common.USERGOODS_MANAGEMENT,
            pername: 'user_goods'
        }
    }, {
        path: 'create',
        name: 'userGoodsCreate',
        component: () => import( /* webpackChunkName: "jp.ticket" */ '@/merchanAdmin/userGoods/detail'),
        meta: {
            zhtitle: zh.m.router.common.CREATE,
            jatitle: ja.m.router.common.CREATE,
            pername: 'user_goods'
        }
    }, {
        path: 'detail',
        name: 'userGoodsDetail',
        component: () => import( /* webpackChunkName: "jp.ticket" */ '@/merchanAdmin/userGoods/detail'),
        meta: {
            zhtitle: zh.m.router.common.EDIT,
            jatitle: ja.m.router.common.EDIT,
            pername: 'user_goods'
        }
    }]
}]
